export function removeEmptyProperties<T>(obj: Record<string, T>): Record<string, T> {
  Object.keys(obj).forEach(key => (obj[key] == null || key === 'undefined') && delete obj[key]);

  return obj;
}

export function defaultIfUndefined<T, R>(currentValue: T | undefined, defaultValue: R): T | R {
  return currentValue || defaultValue;
}